import SizeHelpers from '../common/size-helpers';

const allPhotos = (sizes) => {
  return SizeHelpers.augment.fromCollection(sizes);
};

const photoRootIds = (sizes, fromPhotoCollecton = false) => {
  const photos = fromPhotoCollecton ? sizes : allPhotos(sizes);

  const uniqueRootIds = [
    ...new Set(photos.map((photo) => photo.root_image_id)),
  ];

  // Sort them in descending order (newest first)
  return uniqueRootIds.sort((a, b) => b - a);
};

export default photoRootIds;
